const BASE = 'overdraftProtectionLoan-';
const EASY_LOAN_BASE = 'contractEasyLoan-';
const PERSONAL_LOAN_BASE = 'contractPersonalLoan-';

export default {
  BASE,
  SUBTITLE_CONFIRM_PAGE: `${BASE}subtitleConfirmPage`,
  TEXT_CONFIRM_PAGE: `${BASE}textConfirmPage`,
  TITLE_PDF_VIEWER: `${BASE}titlePdfViewer`,
  TITLE_PDF_DOCUMENT: `${BASE}titlePdfDocument`,
  TITLE_CONTRACT_DRAFT_DOCUMENT: `${BASE}documentsAssociatedConfirmPage`,
  PDF_CHECKBOX: `${BASE}pdfCheckboxAlreadyRead`,
  SIMPLE_EMAIL: `${EASY_LOAN_BASE}pdfSimpleEmailAcceptedText`,
  PDF_CHECKBOX_DEFAULT: `${BASE}pdfCheckboxAlreadyReadDefault`,
  OVERDRAFT_SUBTITLE_STEP4: `${BASE}subtitleStep4`,
  LEGAL_INFO_BUTTON: `${BASE}writeButton`,
  LEGAL_INFO_READ_BUTTON: `${BASE}writtenButton`,
  PDF_CONFIRM_BUTTON: `${BASE}pdfConfirmButton`,
  PDF_CANCEL_BUTTON: `${BASE}pdfCancelButton`,
  OVERDRAFT_TEXT_CONFIRM_PAGE:`${BASE}textConfirmPage`,
  EASY_LOAN_TEXT_CONFIRM_PAGE: `${EASY_LOAN_BASE}textConfirmPage`,
  EASY_LOAN_TITLE_CONTRACT_DRAFT_DOCUMENT: `${EASY_LOAN_BASE}documentsAssociatedConfirmPage`,
  EASY_LOAN_SUBTITLE_STEP4: `${EASY_LOAN_BASE}easyLoanSubTitleStep4`,
  PERSONAL_LOAN_TEXT_CONFIRM_PAGE: `${PERSONAL_LOAN_BASE}textConfirmPage`,
};
